import { render } from "./HeaderTwo.vue?vue&type=template&id=39eee2ef"
import script from "./HeaderTwo.vue?vue&type=script&lang=js"
export * from "./HeaderTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__